import { CURRENCY, LOCALE } from './locale';

export function getCurrencyByLocale(locale: string): string {
	switch (locale) {
		case LOCALE.PL:
			return CURRENCY.PLN;
		case LOCALE.SK:
		case LOCALE.DE:
			return CURRENCY.EUR;
		case LOCALE.CZ:
			return CURRENCY.CZK;
		case LOCALE.RO:
			return CURRENCY.RON;
		default:
			throw new Error(`Unknown locale: ${locale}`);
	}
}

export function formatCurrency(currency: string): string {
	switch (currency) {
		case CURRENCY.PLN:
			return 'zł';
		case CURRENCY.EUR:
			return '€';
		case CURRENCY.CZK:
			return 'Kč';
		case CURRENCY.RON:
			return 'lei';
		default:
			throw new Error(`Unknown currency: ${currency}`);
	}
}

export const formatPrice = (
	price: number,
	locale: string = LOCALE.PL,
	currency?: string
): string => {
	const cleanedLocale = locale.replace('_', '-');
	const cleanedCurrency = currency || getCurrencyByLocale(cleanedLocale);

	if (!cleanedCurrency) {
		throw new Error('Currency not supported');
	}

	return new Intl.NumberFormat(cleanedLocale, {
		style: 'currency',
		currency: cleanedCurrency,
		maximumFractionDigits: cleanedCurrency === CURRENCY.CZK ? 0 : 2,
		minimumFractionDigits: cleanedCurrency === CURRENCY.CZK ? 0 : 2,
	}).format(price / 100);
};

export const formatPriceCurrency = (
	price: number,
	locale: string = LOCALE.PL,
	currency?: string
): { price: string; currency: string } => {
	const cleanedLocale = locale.replace('_', '-');
	const cleanedCurrency = currency || getCurrencyByLocale(cleanedLocale);

	if (!cleanedCurrency) {
		throw new Error('Currency not supported');
	}

	const currencyParts = new Intl.NumberFormat(cleanedLocale, {
		style: 'currency',
		currency: cleanedCurrency,
		maximumFractionDigits: cleanedCurrency === CURRENCY.CZK ? 0 : 2,
		minimumFractionDigits: cleanedCurrency === CURRENCY.CZK ? 0 : 2,
	}).formatToParts(price / 100);

	const formattedPrice = currencyParts
		.map((val) => {
			if (val.type === 'currency') {
				return '';
			}

			return val.value;
		})
		.join('');

	const formattedCurrency = currencyParts.find((val) => val.type === 'currency');

	return {
		price: formattedPrice,
		currency: formattedCurrency?.value.trim() ?? '',
	};
};
